import {
  BakeShadows,
  Environment,
  Lightformer,
  OrbitControls,
  PerformanceMonitor,
  PerspectiveCamera,
  Shadow,

  
} from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import React, {  Suspense, useEffect, useRef, useState } from 'react'
import * as THREE from 'three'
// import { useControls } from 'leva'
import { Depth, LayerMaterial } from 'lamina/vanilla'
import { CrystalModel } from './CrystalModel'

import { EffectComposer, TiltShift2, Bloom } from '@react-three/postprocessing'
import { KernelSize, Resolution } from 'postprocessing'


export default function Scene() {
  const [degraded, degrade] = useState(false)


  const stoneRef = useRef()
  const cameraRef = useRef()

	const mouseX = useRef(0)
  const mouseY = useRef(0)


	const mouseMoveHandler = (event) => {
    mouseX.current = (event.clientX / window.innerWidth) * 2 - 1
    mouseY.current = -(event.clientY / window.innerHeight) * 2 + 1
  }

  useEffect(()=>{
    window.addEventListener('mousemove', mouseMoveHandler)
    
		return () => {
      window.removeEventListener('mousemove', mouseMoveHandler)
    }
  },[])

  useFrame((state, delta) => {
    if (stoneRef.current && cameraRef.current) {
      // stoneRef.current.rotation.y = -Math.PI / 2 - Math.PI * 2.01
      // stoneRef.current.rotation.y = -Math.PI / 2 - Math.PI * 2.01 + Math.PI * state.pointer.x * 50 /180
 console.log(mouseX.current)
            cameraRef.current.position.lerpVectors(
              new THREE.Vector3(
                stoneRef.current.position.x + 6,
                stoneRef.current.position.y + 2,
                -2
              ),
              new THREE.Vector3(6, +2, +1.5),
              (mouseX.current + 1) /2
            ) // Smoothness factor can be adjusted
            cameraRef.current.lookAt(0, 0, 0)
      const targetX = state.pointer.x
      stoneRef.current.rotation.y = -Math.PI / 2 - Math.PI * 2.01 + Math.PI * (targetX * 10 -5) /180

    }
  })
  


  return (
    <Suspense fallback="Loading">
      <PerformanceMonitor onDecline={() => degrade(true)} />
      <Environment
        resolution={256}
        frames={degraded ? 1 : Infinity}
        background={false}
        blur={2}
        preset="studio"
      >
        <Lightformers />
      </Environment>

      {/* <color
        attach="background"
        args={['#080709']}
      /> */}
      <BakeShadows />

      <EffectComposer
        disableNormalPass
        multisampling={4}
      >
        <Bloom
          intensity={0.3} 
          kernelSize={KernelSize.LARGE} 
          luminanceThreshold={0.1} 
          luminanceSmoothing={0.1} 
          mipmapBlur={false} 
          resolutionX={Resolution.AUTO_SIZE}
          resolutionY={Resolution.AUTO_SIZE} 
        />
        <TiltShift2 blur={0.5} />
      </EffectComposer>

      <PerspectiveCamera
        makeDefault
        position={[6, 2, 0]}
        ref={cameraRef}
        // near={0.02}
        // far={2000}
        // fov={40}
      />

      <group
        ref={stoneRef}
        position={[0, -0.8, 0]}
        // rotation={[0, (Math.PI * -90) / 180, (Math.PI * 0) / 180]}
      >
        <Shadow
          opacity={0.15}
          scale={4}
          blur={1}
          far={20}
          resolution={256}
          color="purple"
          position={[0, -0.7, -0.5]}
        />
        <CrystalModel
          scale={2}
          position={[0, -0.5, 0]}
        />
      </group>
      <OrbitControls />
    </Suspense>
  )
}

function Lightformers({ positions = [4, 0, 4, 0, 4, 0, 4, 0] }) {
  const group = useRef(null)

  const material = new LayerMaterial({
    color: '#444',
    layers: [
      new Depth({
        colorA: 'blue',
        colorB: 'black',
        alpha: 0.5,
        mode: 'normal',
        near: 0,
        far: 300,
        origin: new THREE.Vector3(1, 1, 1),
      }),
    ],
  })
  useFrame((state, delta) => {
    if (group.current) {
      if ((group.current.position.z += delta * 2) > 4) {
        group.current.position.z = -40
      }
    }
  })
  return (
    <group rotation={[(Math.PI * 0) / 180, (Math.PI * -80) / 180, (Math.PI * 0) / 180]}>
      {/* Ceiling */}
      <Lightformer
        intensity={0.65}
        rotation-x={Math.PI / 2}
        position={[0, 5, -9]}
        scale={[10, 10, 1]}
      />
      <group rotation={[0, 0.5, 0.2]}>
        <group ref={group}>
          {positions.map((x, i) => (
            <Lightformer
              key={i}
              form="circle"
              intensity={2}
              rotation={[Math.PI / 2, 0, 0]}
              position={[x*4, 4, i * 4]}
              scale={[6, 6, 6]}
            />
          ))}
        </group>
      </group>
      {/* Sides */}
      <Lightformer
        intensity={0.5}
        rotation-y={Math.PI / 2}
        position={[-5, 1, -1]}
        scale={[20, 0.1, 1]}
      />
      <Lightformer
        rotation-y={Math.PI / 2}
        position={[-5, -1, -1]}
        scale={[20, 0.5, 1]}
        intensity={0.2}
      />
      <Lightformer
        rotation-y={-Math.PI / 2}
        position={[10, 1, 0]}
        scale={[20, 1, 1]}
        intensity={0.2}
      />

        <Lightformer
          form="ring"
          color="#6E26C6"
          intensity={0.5}
          scale={4}
          position={[-5, 4, -2]}
          target={[0, 0, 0]}
        />

      {/* Background */}
      <mesh
        scale={100}
        material={material}
      >
        <sphereGeometry args={[1, 64, 64]} />
      </mesh>
    </group>
  )
}
